/*
  Project: Starter Test
  Author: Michał Strześniewski
 */

import a11y from './modules/a11y';
import contextmenu from './modules/contextmenu';
import faq from './modules/faq';
import hover from './modules/hover';
import inputs from './modules/inputs';
import search from './modules/search';
import postSummary from './modules/postSummary';
import slider from './modules/slider';
import tabs from './modules/tabs';
import calendar from './modules/calendar';
import showMore from './modules/showMore';
import tooltip from './modules/tooltip';
import mobileMenu from './modules/mobileMenu';
import mobileSearch from './modules/mobileSearch';
import mobileSliders from './modules/mobileSliders';
import searchFilters from './modules/searchFilters';
import cookies from './modules/cookies';
import cardAdd from './modules/cardAdd';
import login from './modules/login';
import registration from './modules/registration';
import changePassword from './modules/changePassword';
import resetPassword from './modules/resetPassword';
import removeUsr from './modules/removeUsr';
import editUsr from './modules/editUser';
import editConditions from './modules/editConditions';
import personalize from './modules/personalize';
import gallery from './modules/gallery';
import quiz from './modules/quiz';
import breadcrumbs from './modules/breadcrumbs';
import pagination from './modules/pagination';
import relatedPostsScroll from './modules/relatedPostsScroll';
import mobileFilters from './modules/mobileFilters';
import hero from './modules/hero';
import supportForm from './modules/supportForm';
// import loggedinbutton from './modules/loggedinbutton';
import newFormImages from './modules/newFormImages';
import industries from './modules/industries';
import collapseText from './modules/collapseText';

function init() {
  inputs();
  slider();
  hover();
  tabs();
  faq();
  a11y();
  contextmenu();
  search();
  postSummary();
  calendar();
  showMore();
  tooltip();
  mobileMenu();
  mobileSearch();
  mobileSliders();
  searchFilters();
  cookies();
  cardAdd();
  login();
  registration();
  changePassword();
  resetPassword();
  removeUsr();
  editUsr();
  editConditions();
  personalize();
  gallery();
  quiz();
  breadcrumbs();
  pagination();
  mobileFilters();
  supportForm();
  newFormImages();
  industries();
  collapseText();
  window.isInitializedJS = true;
}
document.addEventListener('DOMContentLoaded', () => {
  if (!window.isInitializedJS) {
    init();
    hero();
  }
  // loggedinbutton();

  relatedPostsScroll();
});

document.addEventListener('turbo:load', () => {
  if (!window.isInitializedJS) {
    init();
    hero();
  }
  // loggedinbutton();

  relatedPostsScroll();
});

document.addEventListener('turbo:before-render', () => {
  // console.log();
  // console.log(event);
  // console.log(event.detail.newBody.baseURI.split('?')[0]);
  // console.log(document.location.href.split('?')[0]);
  // event.preventDefault();
  window.isInitializedJS = false;
  document.scrollPositions = {};
  if (!window.navigation.canGoForward) {
    document.querySelectorAll('[data-turbo-permanent]').forEach(element => {
      if (element.href.split('?')[0] === document.location.href.split('?')[0])
        document.scrollPositions[element.id] = window.scrollY;
    });
    document.querySelectorAll('.js-scroll-to-section').forEach(element => {
      document.scrollPositions[element.id] =
        element.getBoundingClientRect().top + window.scrollY;
    });
  }
});
document.addEventListener('turbo:render', () => {
  setTimeout(() => {
    document.querySelectorAll('[data-turbo-permanent]').forEach(element => {
      window.scrollTo(0, document.scrollPositions[element.id]);
    });
    document.querySelectorAll('.js-scroll-to-section').forEach(element => {
      window.scrollTo(0, document.scrollPositions[element.id]);
    });
  }, 100);
  hero();
  // loggedinbutton();
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/app.js